var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33337 7.66732V4.13233C9.33337 3.39017 9.63188 2.67839 10.1632 2.1536C10.6946 1.62881 11.4153 1.33398 12.1667 1.33398C12.9181 1.33398 13.6388 1.62881 14.1702 2.1536C14.7015 2.67839 15 3.39017 15 4.13233V6.37101",
    stroke: "#9DA1AF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77774 8H3.55551C3.0646 8 2.66663 8.48842 2.66663 9.09091V12.9091C2.66663 13.5116 3.0646 14 3.55551 14H9.77774C10.2687 14 10.6666 13.5116 10.6666 12.9091V9.09091C10.6666 8.48842 10.2687 8 9.77774 8Z",
    stroke: "#9DA1AF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.3bf4599ed37e6001226f97de5718ce5b.svg";
export { ForwardRef as ReactComponent };